import type { Action } from "./action-types";
import * as types from "./action-types";
import { filter, isEqual, uniqWith } from "lodash";

const initialState = {
  data: {},
  fetchingGraphDetail: false,
  fetchingGraphData: false,
  GraphDetail: [],
  Description: "",
  Title: "",
  title: "",
  navTitle: "",
  country: "",
  costcenter: "",
  fetchingTotalTillDateByKey: true,
  totalTillDate: [],
  notification: [],
  reportParams: {},
  refreshContentNotificationUpdate: {},
  insightFilters: [],
  fetchingFilter: false
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    // charts

    case types.SET_INSIGHT_DATA: {
      return Object.assign({}, state, {
        data: action.data,
        notification: action.notification,
        title: action.title,
        refreshContentNotificationUpdate: {},
        fetchingGraphData: false,
      });
    }
    /**
     * graph detail
     */
    /*************************Fetch graph detail action states START ***************************/
    case `${types.FETCH_GRAPH_DETAIL}_PENDING`:
      return Object.assign({}, state, {
        GraphDetail: [],
        fetchingGraphDetail: true,
        navTitle: "",
        prevState: {}
      });

    case `${types.FETCH_GRAPH_DETAIL}_FULFILLED`:
      return Object.assign({}, state, {
        GraphDetail: action.payload.data || action.payload.data.Data,
        Description: action.payload.data.Description,
        Title: action.payload.data.Title,
        fetchingGraphDetail: false,
        serverError: false
      });

    case `${types.FETCH_GRAPH_DETAIL}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch GraphDetail action Failed"
      };

    case `${types.SET_FETCH_GRAPH_DATA}`:
      return Object.assign({}, state, {
        fetchingGraphData: action.payload.status,
      });
    /*************************Fetch graph detail action states END ***************************/

    /**
     * // Insight TotalTillDateByKey
     */
    /*************************Fetch TOTAL_TILL_DATE action states START ***************************/
    case `${types.FETCH_TOTAL_TILL_DATE}_PENDING`:
      return Object.assign({}, state, {
        fetchingTotalTillDateByKey: true,
        totalTillDate: []
      });

    case `${types.FETCH_TOTAL_TILL_DATE}_FULFILLED`:
      return Object.assign({}, state, {
        totalTillDate: action.payload.data.Data,
        fetchingTotalTillDateByKey: false,
        serverError: false
      });

    case `${types.FETCH_TOTAL_TILL_DATE}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch TOTAL Till Date action Failed"
      };
    /*************************Fetch TOTAL_TILL_DATE detail action states END ***************************/

    case "INSIGHTS_DRILL_DOWN":
      return {
        ...state,
        GraphDetail: action.drillDownData,
        navTitle: action.navTitle,
        prevState: { ...state }
      };

    case "INSIGHTS_DRILL_UP":
      return {
        ...state,
        ...state.prevState
      };
    /*************************Fetch Summary Details action states START ***************************/
    case `${types.FETCH_SUMMARY_DETAILS}_PENDING`:
      return {
        ...state,
        fetchingSummaryDetail: true
      };

    case `${types.FETCH_SUMMARY_DETAILS}_FULFILLED`:
      return {
        ...state,
        fetchingSummaryDetail: false,
        // use lodash uniqWith & isEqual to filter out uniq object
        GraphDetail: uniqWith(
          [
            // filter out fetched remote component
            ...state.GraphDetail.filter(
              componentDetail =>
                !isEqual(componentDetail.FetchParams, action.meta.FetchParams)
            ),
            ...action.payload.data
          ],
          isEqual
        ),
        navTitle: action.meta.navTitle
        // no need to set prevState as we are fetching remote data
        // prevState: {...state}
      };

    case `${types.FETCH_SUMMARY_DETAILS}_REJECTED`:
      return {
        ...state,
        fetchingSummaryDetail: false,
        error: action.err
      };
    /*************************Fetch Summary Details action states END ***************************/
    /*************************Fetch notification detail action states START ***************************/
    case `${types.FETCH_NOTIFICATION_DETAIL}_PENDING`:
      return Object.assign({}, state, {
        GraphDetail: [],
        fetchingGraphDetail: true,
        navTitle: "",
        prevState: {}
      });

    case `${types.FETCH_NOTIFICATION_DETAIL}_FULFILLED`:
      return Object.assign({}, state, {
        GraphDetail: action.payload.data || action.payload.data.Data,
        Description: action.payload.data.Description,
        Title: action.payload.data.Title,
        fetchingGraphDetail: false,
        serverError: false
      });

    case `${types.FETCH_NOTIFICATION_DETAIL}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch GraphDetail action Failed"
      };
    /*************************Fetch notification detail action states END ***************************/

    /*************************Fetch graph filter START ***************************/
    case `${types.GET_GRAPH_FILTER}_PENDING`:
      return Object.assign({}, state, {
        fetchingFilter: true
      });

    case `${types.GET_GRAPH_FILTER}_FULFILLED`:
      return Object.assign({}, state, {
        fetchingFilter: false,
        insightFilters: action.payload.data.filters
      });

    case `${types.GET_GRAPH_FILTER}_REJECTED`:
      return {
        isRejected: true,
        error: "Fetch graph filter action Failed"
      };
    /*************************Fetch graph filter END ***************************/

    case types.SET_REPORT_PARAMS:
      return Object.assign({}, state, {
        reportParams: action.data
      });

    case types.CLEAR_REPORT_PARAMS:
      return Object.assign({}, state, {
        reportParams: {}
      });

    case `${types.RESET_OTHER_NOTIFICATIONS_UPDATE}`:
      return Object.assign({}, state, {
        refreshContentNotificationUpdate: {}
      });

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/features/insights/reducer.js